import React from "react";
import { AppBar, Toolbar, Typography } from "@mui/material";
import { styled } from "@mui/system";

const AbsoluteDiv = styled("div")({
  position: "absolute",
  display: "flex",
  justifyContent: "space-between", // Align items in the center
  alignItems: "center", // Vertically align items in the center
  width: "100%",
  height: "50px", // Make the div cover the full height of its parent
  backgroundColor: "rgba(3, 31, 7, 0.85)", // Semi-transparent black background
  // backgroundColor: "rgba(0, 0, 0, 0.65)", // Semi-transparent black background
  color: "white", // White text
  padding: "1em", // Padding around the edges
  boxSizing: "border-box",
  zIndex: "3",
});

const ButtonDiv = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  maxWidth: "250px",
  width: "100%",
  [theme.breakpoints.down("sm")]: {
    maxWidth: "200px",
  },
}));

const Text = styled(Typography)(({ theme }) => ({
  fontFamily: "Roboto Slab",
  [theme.breakpoints.down("sm")]: {
    fontSize: "1rem",
  },
}));

const ButtonText = styled(Typography)(({ theme }) => ({
  fontFamily: "Roboto Slab",
  cursor: "pointer",
  fontWeight: "500",
  "&:hover": {
    textDecoration: "underline",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "0.75rem",
  },
}));

const scrollTo = (id) => {
  console.log("hit scroll to");
  document.getElementById(id).scrollIntoView({ behavior: "smooth" });
  console.log("doucment.getElementById(id)", document.getElementById(id));
};

export default function Header() {
  return (
    <AbsoluteDiv>
      <Text variant="h5"> Downieville River House</Text>
      <ButtonDiv>
        <ButtonText variant="h8" onClick={() => scrollTo("property")}>
          Property
        </ButtonText>
        <ButtonText variant="h8" onClick={() => scrollTo("contact")}>
          Contact
        </ButtonText>
      </ButtonDiv>
    </AbsoluteDiv>
  );
}
